export const NoColorIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <g id="Mask group">
          <mask
            id="mask0_10370_438"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="-8"
            y="-7"
            width="38"
            height="37"
          >
            <rect
              id="Rectangle"
              x="17"
              y="-7"
              width="17"
              height="34"
              transform="rotate(45 17 -7)"
              fill="#191919"
            />
          </mask>
          <g mask="url(#mask0_10370_438)">
            <circle
              id="Ellipse"
              cx="17"
              cy="17.0416"
              r="17"
              transform="rotate(45 17 17.0416)"
              fill="#191919"
            />
          </g>
        </g>
        <g id="Mask group_2">
          <mask
            id="mask1_10370_438"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="4"
            y="4"
            width="38"
            height="37"
          >
            <rect
              id="Rectangle_2"
              x="17"
              y="41"
              width="17"
              height="34"
              transform="rotate(-135 17 41)"
              fill="#D9D9D9"
            />
          </mask>
          <g mask="url(#mask1_10370_438)">
            <circle
              id="Ellipse_2"
              cx="17"
              cy="16.9584"
              r="17"
              transform="rotate(-135 17 16.9584)"
              fill="white"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
